<template>
  <div class="flow">
    <div class="aside">
      <div class="title">
        <i class="icon icon-sys"></i>
        <span v-if="type === 'add'">{{ $t('dms_product_item.xin_zeng_chan_pin') }}</span>
        <span v-if="type === 'edit'">{{ $t('dms_product_item.bian_ji_chan_pin') }}</span>
      </div>
      <t-step v-model="step" :list="stepList" @step="onStepChange"></t-step>
      <div class="product-sn" v-if="productCode">{{ productCode }}</div>
    </div>
    <!-- 内容区域 -->
    <div class="section">
      <!-- 产品信息 -->
      <product-item-info v-if="step === 1" :productId="productId" :isAdmin="isAdmin" @cancel="onCancel" @step="onStep" @update="onUpdate"></product-item-info>
      <!-- 产品参数 -->
      <product-item-param v-if="step === 2" :productId="productId" :productCode="productCode" @cancel="onCancel" @step="onStep" @back="onBack"></product-item-param>
      <!-- 产品结构 -->
      <!-- <product-item-component
        v-if="step === 3"
        :productId="productId"
        :productCode="productCode"
        @cancel="onCancel"
        @step="onStep"
        @back="onBack"
      ></product-item-component> -->
      <!-- 产品物模型 -->
      <!-- <product-item-model
        v-if="step === 4"
        :productId="productId"
        :productCode="productCode"
        @cancel="onCancel"
        @step="onStep"
        @back="onBack"
      ></product-item-model> -->
      <!-- 产品协议 -->
      <product-item-protocol v-if="step === 3" :productId="productId" :productCode="productCode" :productSn="productSn" @cancel="onCancel" @step="onStep" @back="onBack"></product-item-protocol>
    </div>
  </div>
</template>

<script>
import tStep from '@/components/step.vue';
import productItemInfo from './product_item_step_info.vue';
import productItemParam from './product_item_step_param.vue';
// import productItemComponent from './product_item_step_component.vue';
// import productItemModel from './product_item_step_model.vue';
import productItemProtocol from './product_item_step_protocol.vue';

export default {
  components: {
    tStep,
    productItemInfo,
    productItemParam,
    // productItemComponent,
    // productItemModel,
    productItemProtocol,
  },
  data() {
    return {
      provide: true,
      productId: '',
      productCode: '',
      productSn: '',
      type: '',

      step: 1,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.userInfo.bizType === 'PF';
    },
    stepList() {
      const list = [
        {
          label: 1,
          value: 1,
          title: this.$t('dms_product_item.chan_pin_xin_xi'),
          subTitle: this.$t('dms_product_item.jbxxbj'),
        },
        {
          label: 2,
          value: 2,
          title: this.$t('dms_product_item.chan_pin_can_shu'),
          subTitle: this.$t('dms_product_item.cpcssz'),
        },
        {
          label: 3,
          value: 3,
          title: this.$t('dms_product_item.chan_pin_xie_yi'),
          subTitle: this.$t('dms_product_item.cpxyxz'),
        },
      ];
      return this.isAdmin ? list : list.slice(0, 1);
    },
  },
  mounted: function () {

    this.productId = this.getJump('productId') || '';
    this.productCode = this.getJump('productCode') || '';
    this.productSn = this.getJump('productSn') || '';
    this.type = this.productId ? 'edit' : 'add';
    // this.clearKeepAlive('product');
  },
  methods: {
    onStepChange(step) {
      if (this.type === 'edit') {
        this.step = step;
      }
    },
    // 取消
    onCancel: function () {
      this.jump('/product/list', {}, true);
    },
    // 上一步
    onBack: function () {
      this.step--;
    },
    // 下一步
    onStep: function (val) {
      if (val && val.name === 'info') {
        this.productId = val.productId;
        this.productCode = val.productCode;
        this.productSn = val.productSn;
      }
      this.step++;
    },
    onUpdate: function (val) {
      this.productId = val.productId;
      this.productCode = val.productCode;
      this.productSn = val.productSn;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.flow {
  .product-sn {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #eef2f8;
    font-size: 14px;
    color: #495057;
    z-index: 100;
  }
}
</style>
